import React, { Component } from "react";
import { Button, Image, Modal } from "semantic-ui-react";
import AnalysisDetailsField from "features/FolderManager/components/Prescription/AnalysisDetailsField";
import AnalysisWarnings from "./AnalysisWarnings";

const styles = {
	headerAnalysisCircle: {
		padding: "1em",
		marginBottom: "2em",
		textAlign: "center",
	},
	circleAnalysis: {
		height: 50,
		width: 50,
		borderRadius: "50%",
		border: "1px solid #5f9be0",
		textAlign: "center",
		lineHeight: "48px",
		fontWeight: 600,
		color: "#5f9be0",
		cursor: "pointer",
		fontSize: "0.7em",
		boxShadow: "rgba(0, 0, 0, 0.14) 0px -5px 17px -5px inset, rgb(148, 148, 148) 0px 9px 13px -10px",
		margin: "auto",
	},
	circleTitle: {
		fontSize: "0.6em",
		height: 20,
		lineHeight: "1em",
		display: "flex",
		alignItems: "center",
	},
	tubesContainer: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	tube: {
		maxWidth: 90,
		margin: "1em",
	},
	header: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		flexWrap: "wrap",
	},
	headerLeft: {
		width: "30%",
	},
	headerRight: {
		width: "70%",
	},
	containerField: {
		fontSize: "0.9em",
		width: "100%",
		marginBottom: 5,
	},
	label: {
		fontWeight: 600,
	},
	textField50: {
		width: "50%",
	},
	textField40: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		textAlign: "center",
	},
	textField35: {
		width: "35%",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
	},
};

class AnalysisDetailsModal extends Component {
	close = () => (this.props.open = false);

	displayTreatmentDay = (analysis) => {
		let days = [];
		if (analysis.treatment_day_monday) days.push("lundi");
		if (analysis.treatment_day_tuesday) days.push("mardi");
		if (analysis.treatment_day_wednesday) days.push("mercredi");
		if (analysis.treatment_day_thursday) days.push("jeudi");
		if (analysis.treatment_day_friday) days.push("vendredi");
		if (analysis.treatment_day_saturday) days.push("samedi");
		if (analysis.treatment_day_sunday) days.push("dimanche");

		return days.join(", ");
	};

	render() {
		const { open, analysis, close } = this.props;
		return (
			<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				{analysis !== null && (
					<Modal.Content>
						<div style={{ width: "100%", display: "flex", margin: "1em 3em", paddingRight: "3em" }}>
							<div>
								<b style={{ color: "#4092e8", fontSize: "1.3em" }}>{analysis.label}</b>
								<br />
								<br />

								{analysis.description && (
									<AnalysisDetailsField label="Synonymes" field={analysis.description ? analysis.description.split(";").join(", ") : "/"} />
								)}
								<AnalysisWarnings analysis={analysis} />
								{analysis.waiting_time_before_sampling > 0 && (
									<AnalysisDetailsField
										label="Temps d'attente avant prélèvement"
										field={
											analysis.waiting_time_before_sampling < 60
												? analysis.waiting_time_before_sampling + " min"
												: analysis.waiting_time_before_sampling / 60 > 24
												? analysis.waiting_time_before_sampling / 1440 + " jours"
												: analysis.waiting_time_before_sampling / 60 + " heure(s)"
										}
									/>
								)}
							</div>
						</div>

						<br />
						{analysis.tubes && analysis.tubes.length > 0 && (
							<div style={{ width: "100%", margin: "1em 3em", paddingRight: "3em" }}>
								<div
									style={{
										marginTop: 20,
										marginBottom: 10,
										fontWeight: 600,
										width: "100%",
										color: "#4092e8",
									}}
								>
									Tube(s)
								</div>

								<div style={styles.tubesContainer}>
									{analysis.tubes.map((tube) => (
										<div style={styles.tube} key={`tube-${tube.id}`}>
											<Image
												size="small"
												src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
													tube.picto ? tube.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME
												}`}
											/>
											<div style={{ fontSize: "0.8em", textAlign: "center" }}>{tube.label}</div>
										</div>
									))}
								</div>
							</div>
						)}
						<br />

						<div style={{ width: "100%", display: "flex", margin: "1em 3em", paddingRight: "3em" }}>
							<div style={{ paddingRight: 10 }}>
								<b style={{ color: "#4092e8" }}>Prélèvement</b>
								<br />
								<br />

								<AnalysisDetailsField
									label="Délai de stabilité"
									field={
										analysis.pretreatment_stability > 0
											? analysis.pretreatment_stability < 60
												? analysis.pretreatment_stability + " min"
												: analysis.pretreatment_stability / 60 > 24
												? analysis.pretreatment_stability / 1440 + " jours"
												: analysis.pretreatment_stability / 60 + " heure(s)"
											: "non précisé"
									}
								/>

								{analysis.pretreatment_note && <AnalysisDetailsField label="Commentaires pré-traitement" field={analysis.pretreatment_note} />}
								<AnalysisDetailsField
									label="Délai de rajout"
									field={
										analysis.analysis_addition_time_limit > 0
											? analysis.analysis_addition_time_limit < 60
												? analysis.analysis_addition_time_limit + " min"
												: analysis.analysis_addition_time_limit / 60 > 24
												? analysis.analysis_addition_time_limit / 1440 + " jours"
												: analysis.analysis_addition_time_limit / 60 + " heure(s)"
											: "non précisé"
									}
								/>

								<AnalysisDetailsField
									label="Délai de rendu"
									field={
										analysis.time_to_results > 0
											? analysis.time_to_results < 60
												? analysis.time_to_results + " min"
												: analysis.time_to_results / 60 > 24
												? analysis.time_to_results / 1440 + " jours"
												: analysis.time_to_results / 60 + " heure(s)"
											: "non précisé"
									}
								/>
								<div style={styles.containerField}>
									<span style={styles.label}>Jours de prélèvement</span> :
									<span style={{ paddingLeft: "5px" }}>{this.displayTreatmentDay(analysis)}</span>
								</div>

								{/* {analysis.taking_note && <AnalysisDetailsField
									label='Commentaires prélèvement'
									field={analysis.taking_note || '/'}
								/>} */}
							</div>
						</div>

						<br />
					</Modal.Content>
				)}

				<Modal.Actions>
					<Button
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							close();
						}}
					>
						Fermer
					</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}

export default AnalysisDetailsModal;
